import { APP_ROUTES, toRouteParam } from '@efficiently/client-core-routing';

const PATH_SEPARATOR = '/';

/**
 * Returns the absolute route path of a Supply Item Schedule sub-tab, with `:projectId` as a placeholder.
 *
 * @param subTabPath The sub-tab's path relative to the Supply Item Schedule, e.g. `rooms/:view`.
 * @returns The absolute path, e.g. `/supply/projects/:projectId/item-schedule/rooms/:view`.
 */
export function toSupplyItemSchedulePath(subTabPath: string): string {
	const segments: readonly string[] = [
		APP_ROUTES.SUPPLY.path,
		APP_ROUTES.SUPPLY_PROJECT.path,
		toRouteParam(APP_ROUTES.SUPPLY_PROJECT.PARAMS.PROJECT_ID),
		APP_ROUTES.SUPPLY_ITEM_SCHEDULE.path,
		subTabPath,
	];

	return `${PATH_SEPARATOR}${segments.join(PATH_SEPARATOR)}`;
}
